import { connect } from 'react-redux';
import PasscodeModal from 'components/PasscodeModal/PasscodeModal';
import { callActions } from '@lifesize/nucleus';
import actions from 'actions/PasscodeModal';

const MAX_TRIES = 10;

const mapDispatchToProps = (dispatch) => ({
  submitPasscode: (passcodeForm) =>
    new Promise((resolve, reject) => {
      if (passcodeForm.numTries < MAX_TRIES) {
        dispatch(callActions.sendMeetingPin(passcodeForm.passcode))
          .then(() => {
            resolve();
          })
          .catch(() => {
            dispatch(actions.invalidPasscode());
            if (reject) {
              reject();
            }
          });
      } else {
        dispatch(callActions.end());
        reject();
      }
    })
});

const mapStateToProps = (state) => ({
  initialValues: { numTries: 1 }
});

export default connect(mapStateToProps, mapDispatchToProps)(PasscodeModal);
